import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles, Grid, Button, Paper } from '@material-ui/core';
import Highcharts from 'highcharts';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import { withTranslation } from 'react-i18next';
import PageTitle from '../../components/PageTitle/PageTitle';
import SelectTenant from '../../components/Select/SelectTenant';
import { setSelectTenant } from '../../utils/common';
import CalendarDateRange from './components/DatePicker/CalendarDateRange';
import RouterChart from './components/Chart/RouterChart';
import Swal from 'sweetalert2';
import moment from 'moment';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);

class RouterUsageSummary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      tenant: '',
    };
  }

  async componentDidMount() {
    // const { tenantIds } = this.props.device.toJS();
    const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
    this.setState({
      tenant: tenantIds ? JSON.stringify(tenantIds) : '',
    });
    if (tenantIds && tenantIds.length > 0) {
      this.props.usageSummary.setData('tenantIds', tenantIds && JSON.stringify(tenantIds));
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.props.usageSummary.setData(name, value);
  };

  onSubmit = async () => {
    const { t } = this.props;
    const { tenantIds } = this.props.usageSummary.toJS();
    const { startDate, endDate } = this.state;
    const startDateTime = moment(new Date(`${startDate}`))
      .toDate()
      .getTime();
    const endDateTime = moment(new Date(`${endDate}`))
      .toDate()
      .getTime();

    if (startDateTime > endDateTime) {
      Swal.fire({
        html: `<h4>${t('invalid_format')}`,
        type: 'warning',
      });
    } else {
      const startDateFormate = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(-2)}-${('0' + startDate.getDate()).slice(-2)}`;
      const endDateFormate = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(-2)}-${('0' + endDate.getDate()).slice(-2)}`;
      try {
        if (tenantIds && tenantIds.length > 0) {
          this.props.usageSummary.setRenderHighchart();
          await this.props.usageSummary.getSummaryRouter(
            startDateFormate,
            endDateFormate,
            tenantIds ? tenantIds : [],
          );
        }
      } catch (error) {
        console.log('error: ', error);
      }
    }
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
    this.props.usageSummary.setRenderHighchart(false);
  };

  onEndDateChange = (date) => {
    this.setState({ endDate: date });
    this.props.usageSummary.setRenderHighchart(false);
  };

  titleContent() {
    const { classes, t } = this.props;
    // const { start, end } = this.props.usageSummary.toJS();
    const { startDate, endDate } = this.state;
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} allTenantsHiding={true} />
        <Grid className={classes.wrapCalendar}>
          <CalendarDateRange
            startDateLable={t('start_date')}
            endDateLable={t('end_date')}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={this.onStartDateChange}
            onEndDateChange={this.onEndDateChange}
          />
          <Button
            color='primary'
            variant='contained'
            className={classes.btnApply}
            onClick={() => this.onSubmit()}
            disabled={this.state.tenant ? false : true}
          >
            {t('apply')}
          </Button>
        </Grid>
        {/* <Grid className={classes.wrapText}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
            <TextField
              name="start"
              variant="outlined"
              value={start}
              onChange={(e) => this.handleChange(e)}
              className={classes.contentInput}
              placeholder={t("start_date")}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
            <TextField
              name="end"
              variant="outlined"
              value={end}
              onChange={(e) => this.handleChange(e)}
              className={classes.contentInput}
              placeholder={t("end_date")}
            />
          </FormControl>
        </Grid>
        <Grid container item sm={2}>
        <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
                      <Button
            color="primary"
            variant="contained"
            style={{
              height: 38,
              width: 100
            }}
            className={classes.wrapButton}
            onClick={() => this.onSubmit()}
          >
            {t('apply')}
          </Button>
            </FormControl>
        </Grid> */}
      </div>
    );
  }

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    this.props.usageSummary.setData('tenantIds', value);

    setSelectTenant(tenantIds);
  };

  render() {
    let { t, classes } = this.props;

    const tmp = (
      <React.Fragment>
        <PageTitle title={t('router_usage_summary')}>{this.titleContent()}</PageTitle>
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item xs={12}>
            <Paper className={classes.paperList}>
              <RouterChart />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
    return tmp;
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  actionBox: {
    minWidth: '480px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  gridMenu: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 14,
    marginBottom: theme.spacing.unit * 10,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
    marginLeft: '-8px',
    [theme.breakpoints.down('md')]: {
      marginLeft: '-8px',
    },
  },
  wrapText: {
    display: 'flex',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
  btnApply: {
    marginLeft: 18,
    marginTop: 4,
    display: 'flex',
    height: 38,
    width: 95,
    boxShadow: 'none',
    justifyContent: 'center',
    // [theme.breakpoints.down("md")]: {
    //   marginTop: 10,
    // },
  },
  wrapCalendar: {
    display: 'flex',
    width: '520px',
    marginTop: 6,
  },
});

export const page = inject('usageSummary')(observer(RouterUsageSummary));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
